import Model from './Model'

export default class StockTransfer extends Model {
  resource () {
    return 'stock-transfers'
  }
}
